import React from 'react';
import { createPortal } from 'react-dom';

export type ToastType = 'loading' | 'success' | 'error' | 'copy';

interface UniversalToastProps {
  type: ToastType;
  message: string;
  show: boolean;
}

const UniversalToast: React.FC<UniversalToastProps> = ({ type, message, show }) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'loading':
        return <div className="universal-toast-spinner"></div>;
      case 'success':
        return <div className="universal-toast-icon">✓</div>;
      case 'error':
        return <div className="universal-toast-icon">×</div>;
      case 'copy':
        return <div className="universal-toast-icon">✓</div>;
      default:
        return null;
    }
  };

  const getContainerClass = () => {
    return `universal-toast ${type}`;
  };

  const getContentClass = () => {
    return 'universal-toast-content';
  };

  const getTextClass = () => {
    return 'universal-toast-text';
  };

  return createPortal(
    <div className={getContainerClass()}>
      <div className={getContentClass()}>
        {getIcon()}
        <span className={getTextClass()}>{message}</span>
      </div>
    </div>,
    document.body
  );
};

export default UniversalToast;
